const defaultFilter = function defaultFilter<T>(
  entities: T[],
  searchQuery: string,
  getDisplayName: (e: T) => string
): T[] {
  const lowerCaseQuery = searchQuery.trim().toLowerCase();
  return lowerCaseQuery
    ? entities.filter((entity) => getDisplayName(entity).toLowerCase().includes(lowerCaseQuery))
    : entities;
};

export default defaultFilter;
